import {
  GroupedBackendLinesQueryRuns,
  GroupedBucketedQueryRuns,
  GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

export function isAggregatedRuns(
  runs:
    | GroupedBucketedQueryRuns
    | GroupedBackendLinesQueryRuns
    | null
    | undefined
): runs is GroupedBucketedQueryRunWithGroupedRunConnection {
  return runs?.__typename === 'GroupedRunConnection';
}
